import { Injectable } from '@angular/core';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { IPhotoArea, PhotoArea } from '../interfaces/photo-area';
import { BaseDataService } from './base.data.service';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class PhotoAreaService extends BaseDataService {
  url = 'api/photo-area';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  getAll(): Promise<IPhotoArea[]> {
    return this.handleRequest(
      this.http.get<IPhotoArea[]>(`${this.url}/all`),
      this.handlersFactory.getDefault(),
    );
  }
}
